module.exports = __webpack_public_path__ + "img/666615900.d53bd22c.jpg";